<template>
  <div
    class="button-back_bbk"
    @click="next"
    :class="{ [curTheme]: true }"/>
</template>

<script>
export default {

  props: {
    useHistory: {
      type: Boolean,
      default: false,
    },
    defaultRoute: {
      type: String,
      default: '/',
    },
  },

  methods: {
    next() {
      if (window.history.length >= 2) {
        this.$router.go(-1);
      } else {
        this.$router.push({ path: this.defaultRoute });
      }
    },
  },

};
</script>

<style lang="scss">
@import '../styles/common/main';

.button-back_bbk {
  width: 50px;
  height: 50px;
  background: 50% 50% no-repeat url(../../static/grx/icons/btn-back.svg);
  background-size: contain;
  cursor: pointer;
  opacity: .8;
  @include transition;
  &:hover {
    opacity: 1;
    @include transform(scale(1.05));
  }

  &.theme-w {
    opacity: .15;
    &:hover {
      opacity: .3;
      @include transform(scale(1.05));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ButtonBack.vue